import { siteConfig } from '../data/siteConfig';

export function FloatingWhatsApp() {
  return (
    <a
      aria-label="Chat on WhatsApp"
      href={`${siteConfig.whatsapp}?text=Hello%2C%20I%20would%20like%20to%20enquire%20about%20your%20products.`}
      className="fixed bottom-5 right-5 z-[2147483647] grid h-14 w-14 place-items-center rounded-full bg-[#25D366] text-white shadow-soft ring-2 ring-white transition hover:-translate-y-1 hover:scale-105"
      target="_blank"
      rel="noreferrer"
    >
      <svg className="h-7 w-7" viewBox="0 0 32 32" fill="currentColor" aria-hidden="true">
        <path d="M16.02 3.2A12.72 12.72 0 0 0 5.14 22.5L3.4 28.8l6.45-1.68A12.72 12.72 0 1 0 16.02 3.2Zm0 23.3a10.5 10.5 0 0 1-5.35-1.46l-.38-.23-3.82 1 1.02-3.72-.25-.39a10.51 10.51 0 1 1 8.78 4.8Zm5.76-7.87c-.31-.16-1.86-.92-2.15-1.02-.29-.11-.5-.16-.71.16-.21.31-.82 1.02-1 1.23-.19.21-.37.24-.69.08-.31-.16-1.33-.49-2.54-1.56-.94-.84-1.57-1.88-1.75-2.19-.19-.32-.02-.49.14-.65.14-.14.31-.37.47-.55.16-.19.21-.32.31-.53.11-.21.06-.4-.03-.55-.08-.16-.71-1.71-.97-2.34-.26-.61-.52-.53-.71-.54h-.61c-.21 0-.55.08-.84.4-.29.31-1.1 1.08-1.1 2.63s1.13 3.05 1.29 3.26c.16.21 2.22 3.39 5.38 4.75.75.32 1.34.52 1.8.66.76.24 1.45.21 1.99.13.61-.09 1.86-.76 2.12-1.5.26-.73.26-1.36.18-1.5-.08-.13-.29-.21-.6-.37Z" />
      </svg>
    </a>
  );
}
